import "./AcademyModal";
import "./AcademyUtilities";
import "./ShrinkingHeader"; 
 
export function bindCaretToggle() {
    const caretToggle = $(".fa-caret-down");
    caretToggle.on('keydown', function (e) {
        const spacebarKey = ' ';
        const enterKey = 'Enter'; 
        if (e.key === enterKey || e.key === spacebarKey) {
            if (caretToggle.attr('aria-expanded') === 'true') {
                caretToggle.attr('aria-expanded', 'false');
            }
            else {
                caretToggle.attr('aria-expanded', 'true');
            }
            caretToggle.click();
        }
    });
}
bindCaretToggle();